module.exports = __webpack_public_path__ + "static/media/playlist.3d7ed9db.png";